// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.contactemail.RentalManagerUserPropertyContactEmailWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyContactEmailWebApiHandler_purge } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertyContactEmailDeliverabilityResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface PurgeParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyContactEmailWebApiHandler_purge_Args {
  getParams: PurgeParams;
}

export type RentalManagerUserPropertyContactEmailWebApiHandler_purge_Options = UseMutationOptions<
  UserPropertyContactEmailDeliverabilityResponseWebDto,
  unknown,
  RentalManagerUserPropertyContactEmailWebApiHandler_purge_Args
>;

/**
 * Purge contact email with bounce or spam report
 */
export const useRentalManagerUserPropertyContactEmailWebApiHandler_purge = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyContactEmailWebApiHandler_purge_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyContactEmailWebApiHandler_purge_Args) =>
      RentalManagerUserPropertyContactEmailWebApiHandler_purge(args.getParams, httpClient),
  });
};
